import React, { useEffect,useState } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import PrivateRoute from "./PrivateRoute";
import PublicRoute from "./PublicRoute";
import * as view from '../screens';
import Header from '../common/component/Header';
import SideMenu from '../common/component/SideMenu';
import PageNotFound from '../common/component/PageNotFound';
import HospitalFacility from "../screens/pages/HospitalFacility";
import HospitalRetail from "../screens/pages/HospitalRetail";


const AppRouter = () => {

  const Login=React.lazy(() => import("../screens/auth/Login"));
  const ChangePassword=React.lazy(() => import("../screens/auth/ChangePassword"));
  const ForgotPassword=React.lazy(() => import("../screens/auth/ForgotPassword"));
  const ResetPassword=React.lazy(() => import("../screens/auth/ResetPassword"));
  const OtpVerification=React.lazy(() => import("../screens/auth/OtpVerification"));

  const Dashboard = React.lazy(() => import("../screens/pages/DashboardContent"));
  const PageNotFound=React.lazy(() => import("../common/component/PageNotFound"));
  const Table=React.lazy(()=>import('../screens/pages/Table'));
  const AdminPP=React.lazy(()=>import('../screens/pages/AdminPP'));
  const Patient=React.lazy(()=>import('../screens/pages/Patient'));
  const PatientView=React.lazy(()=>import('../screens/pages/PatientView'));
  const HospitalFacility=React.lazy(()=>import('../screens/pages/HospitalFacility'));
  const HospitalPharamacy=React.lazy(()=>import('../screens/pages/HospitalPharmacy'));
  const HospitalStructure=React.lazy(()=>import('../screens/pages/HospitalStructure'));
  const HospitalRetail=React.lazy(()=>import('../screens/pages/HospitalRetail'))
  const TherapeuticPlan=React.lazy(()=>import('../screens/pages/PlanTherapeutic'))
  const Drugs=React.lazy(()=>import('../screens/pages/Drugs'))
  const HospitalPharmacySupervisor=React.lazy(()=>import('../screens/pages/UserHospitalPharSupervisior'));
  // fallback={<div>Loading translations...</div>}  <view.Login />
  return( 
    <Router>
    <Routes>
  
      <Route element={<PublicRoute />}>
      <Route path="/" element={<React.Suspense><Login /></React.Suspense>} />
        <Route path="/login" element={<React.Suspense><Login /></React.Suspense>} />
        <Route path="/forgotPassword" element={<React.Suspense><ForgotPassword /></React.Suspense>} />
        <Route path="/resetPassword" element={<React.Suspense><ResetPassword /></React.Suspense>} />
        <Route path="/changePassword" element={<React.Suspense><ChangePassword /></React.Suspense>} />
        <Route path="/otpVerification" element={<React.Suspense><OtpVerification /></React.Suspense>} />
      </Route>
      <Route element={<PrivateRoute />}><Route path="/" element={<React.Suspense><Dashboard /></React.Suspense>} />
      <Route path="/dashboard" element={<React.Suspense><Dashboard /></React.Suspense> } />
      <Route path="/qcadmin" element={<React.Suspense><AdminPP /></React.Suspense> } />
      <Route path="/hospital-pharmacy-supervisor" element={<React.Suspense><HospitalPharmacySupervisor /></React.Suspense> } />
      <Route path="/asl" element={<React.Suspense><AdminPP /></React.Suspense> } />
      <Route path="/hospital-pharmacy-operators" element={<React.Suspense><AdminPP /></React.Suspense> } />
      <Route path="/medicaladmin" element={<React.Suspense><AdminPP /></React.Suspense> } />
      <Route path="/doctors" element={<React.Suspense><AdminPP /></React.Suspense> } />
      <Route path="/qcoperators" element={<React.Suspense><AdminPP /></React.Suspense> } />
      <Route path="/retail-pharmacy-supervisors" element={<React.Suspense><AdminPP /></React.Suspense> } />
      <Route path="/retail-pharmacy-operators" element={<React.Suspense><AdminPP /></React.Suspense> } />
      <Route path="/attendees" element={<React.Suspense><Patient /></React.Suspense> } />
      {/* <Route path="/hospital-facilities" element={<React.Suspense><HospitalFacility /></React.Suspense> } /> */}
      <Route path="/attendees/scheda-assistito" element={<React.Suspense><PatientView /></React.Suspense> } />
      <Route path="/hospital-facilities" element={<React.Suspense><HospitalStructure/></React.Suspense>} />
      <Route path="/hospital-retail"element={<React.Suspense><HospitalRetail/></React.Suspense>}/>
      <Route path="/hospital-pharmacy"element={<React.Suspense><HospitalPharamacy/></React.Suspense>}/>
      <Route path="/treatment-plans"element={<React.Suspense><TherapeuticPlan/></React.Suspense>}/>
      <Route path="/Drugs"element={<React.Suspense><Drugs/></React.Suspense>}/>
      <Route path="*" element={  <React.Suspense><PageNotFound /></React.Suspense>}/><Route path="/table" element={<React.Suspense><Table /></React.Suspense>}/>
      </Route>

      <Route path="*" element={<React.Suspense>
            <PageNotFound />
          </React.Suspense>}/>
    </Routes>
  </Router>


  )
}

export default AppRouter;
// 

